






































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { DataApi } from './models/Add.model';

import { fetchAdd } from './fetchAdd';

import { ParamApiGenerarMovimiento } from './models/Add.model';
import { boolean } from 'yup';

@Component({ components: {} })
export default class AddGenerarMovimiento extends Vue {
  @Prop({ required: true, default: false }) show!: boolean;
  @Prop({ required: true, default: {} }) data!: DataApi;

  readonly loadingService: LoadingService = new LoadingService();
  readonly $snotify: Snotify = null;
  dialog: boolean = false;
  loading: boolean = false;
  disabledBtn: boolean = false;
  paramApi: ParamApiGenerarMovimiento = {
    usuario: {
      id: '',
      nombre: '',
      rut: '',
    },
    operacion: {
      operacion_id: '5',
      operacion_name: '',
    },
    origen: {
      tipoubicaid: '',
      tipoubicaname: '',
      tipoubicabaja: '',
    },
    destino: {
      tipoubicaid: '',
      tipoubicaname: '',
    },
    numDespacho: {
      despanumero: '',
      despaseguimiento: '',
    },
    movicajanro: '',
    estado: {
      estado_id: '1',
      estado_name: '',
    },
    moviobs: '',
  };

  listApi: Record<string, any[]> = {
    operaciones: [],
    destinos: [],
    destinosDisponibles: [],
    numDespachos: [],
    estados: [],
  };

  mounted() {
    this.dialog = this.show;
    this.getValues();
  }

  async getValues(): Promise<void> {
    try {
      this.loading = true;
      const userId = JSON.parse(
        window.localStorage.getItem('user').replace(/'/g, '"')
      ).id;
      this.loadingService.showLoading(null, 'getLastNumber');
      const result = await fetchAdd({
        endpoint: 'get_movi_values',
        body: { user_id: userId, data: this.data },
      });
      const {
        CODIGO_RESPUESTA,
        MENSAJE_RESPUESTA,
        USER,
        OPERACIONES,
        DESTINOS,
        NUM_DESPACHOS,
        ESTADOS,
        UBICA_ORIGEN,
        numero_despacho,
      } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        return;
      }

      // Valores iniciales
      this.paramApi.usuario = USER[0];
      this.listApi.operaciones = OPERACIONES;
      this.listApi.destinos = DESTINOS;
      this.listApi.destinosDisponibles = DESTINOS.filter(
        (x: any) => x.tipoubicaid !== UBICA_ORIGEN && x.tipoubicabaja !== 't'
      );
      this.paramApi.origen.tipoubicaid = UBICA_ORIGEN;
      this.listApi.numDespachos = NUM_DESPACHOS;
      this.listApi.estados = ESTADOS;
      this.paramApi.numDespacho = numero_despacho;
    } catch (err) {
      console.error('Error: ', err);
    } finally {
      this.loading = false;
      this.loadingService.hideLoading('getLastNumber');
    }
  }

  handleChange(): void {
    this.disabledBtn =
      this.paramApi.destino.tipoubicaid && this.paramApi.estado.estado_id
        ? false
        : true;
  }

  handleSubmit(): void {
    if (!this.paramApi.destino.tipoubicaid || !this.paramApi.estado.estado_id) {
      this.$snotify.error(
        'Debe llenar todos los datos marcados como obligatorios',
        { timeout: 3000 }
      );
      this.disabledBtn = true;
      return;
    }
    this.update();
  }

  rules: Record<string, Object> = {
    textareaCounter: (val: string) =>
      val && val.length > 500
        ? 'Solo se permite como máximo 500 caracteres'
        : true,
    destino: (val: any) =>
      !val.tipoubicaid || !val.tipoubicabaja ? 'El destino es requerido' : true,
  };

  handleClosed({ reload = false }: { reload?: boolean }): void {
    this.dialog = false;
    this.$emit('cerrar', reload);
  }

  async update(): Promise<void> {
    const newMovimiento = {
      nombre_ndv: this.data.nombre_ndv,
      id_add: this.data.id,
      estado_conecta: this.data.estado_conecta,
      ...this.paramApi,
    };

    try {
      this.loadingService.showLoading(null, 'update');

      const result = await fetchAdd({
        endpoint: 'insert_devices',
        body: { ...newMovimiento },
      });
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        return;
      }
      this.handleClosed({ reload: true });
      this.$snotify.success(MENSAJE_RESPUESTA, { timeout: 3000 });
    } catch (err) {
      this.$snotify.error('Ocurrió un error inesperado, por favaor reintente', {
        timeout: 3000,
      });
      console.error('Error: ', err);
    } finally {
      this.loadingService.hideLoading('update');
    }
  }
}
